import { Theme } from "@mui/material/styles";

// The report table's pinned parts: the header (two rows), No + the name column on the left, and
// the totals row (FOOT_ROW_SX), so 27+ branches × 31 days stay readable while scrolling.

const NUMBER_COLUMN_WIDTH = 48;
const NAME_COLUMN_MIN_WIDTH = 220;
/** The first header row's height; the second header row pins just below it. */
export const HEAD_ROW_HEIGHT = 34;
export const TABLE_MAX_HEIGHT = 620;

const pinnedLeft = (left: number) => ({
  position: "sticky" as const,
  left,
  zIndex: 1,
  bgcolor: "inherit",
});

export const NUMBER_CELL_SX = {
  ...pinnedLeft(0),
  width: NUMBER_COLUMN_WIDTH,
  minWidth: NUMBER_COLUMN_WIDTH,
} as const;

export const NAME_CELL_SX = {
  ...pinnedLeft(NUMBER_COLUMN_WIDTH),
  minWidth: NAME_COLUMN_MIN_WIDTH,
  borderRight: 1,
  borderColor: "divider",
} as const;

/** A header cell over a pinned column sits above both the header and the pinned body cells. */
const PINNED_HEAD_Z_INDEX = 3;

export const NUMBER_HEAD_SX = { ...NUMBER_CELL_SX, zIndex: PINNED_HEAD_Z_INDEX } as const;
export const NAME_HEAD_SX = { ...NAME_CELL_SX, zIndex: PINNED_HEAD_Z_INDEX } as const;

export const FIRST_HEAD_ROW_SX = {
  "& th": {
    height: HEAD_ROW_HEIGHT,
    bgcolor: (theme: Theme) => theme.palette.background.default,
    fontWeight: 600,
    textAlign: "center",
  },
} as const;

export const SECOND_HEAD_ROW_SX = {
  "& th": {
    top: HEAD_ROW_HEIGHT,
    bgcolor: (theme: Theme) => theme.palette.background.default,
    fontWeight: 600,
    textAlign: "center",
  },
} as const;

/**
 * The totals row, pinned to the bottom. It sets no text colour, so its cells keep their tone and
 * a negative total stays in the critical colour.
 */
export const TOTAL_ROW_SX = {
  "& td": {
    position: "sticky",
    bottom: 0,
    bgcolor: (theme: Theme) => theme.palette.grey[200],
    fontWeight: 600,
    borderTop: 2,
    borderColor: "divider",
  },
} as const;

/** The totals row's label spans No and the name column, pinned like them. */
export const TOTAL_LABEL_SX = {
  left: 0,
  zIndex: PINNED_HEAD_Z_INDEX,
} as const;
